<template>
    <span class="rounded-full py-0 px-6 mr-5 font-bold text-sm border-2 border-solid md:hidden inline-block">
        {{ current }} {{ trans('clients.of') }} {{ total }}
    </span>
</template>

<script>

export default {
    props: {
        current: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        }
    },
}
</script>
